/**
 * Professional Navigation - Interaction Logic
 * RubberMatting-Direct.co.uk
 */
(function() {
  'use strict';

  const HOVER_DELAY = 100;
  const CLOSE_DELAY = 200;
  let closeTimer = null;
  let currentOpen = null;

  function init() {
    const nav = document.querySelector('.pro-nav');
    if (!nav) return;

    const megaItems = nav.querySelectorAll('.pro-nav__item--mega');
    const dropdownItems = nav.querySelectorAll('.pro-nav__item--dropdown');

    // Mega menu interactions
    megaItems.forEach(item => {
      const trigger = item.querySelector('.pro-nav__link');
      const mega = item.querySelector('.pro-mega');
      if (!trigger || !mega) return;

      // Mouse enter
      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        
        // Close others
        if (currentOpen && currentOpen !== item) {
          closeMenu(currentOpen);
        }

        setTimeout(() => {
          openMenu(item, trigger, mega);
        }, HOVER_DELAY);
      });

      // Mouse leave
      item.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          closeMenu(item, trigger, mega);
        }, CLOSE_DELAY);
      });

      // Click for touch devices
      trigger.addEventListener('click', (e) => {
        if (trigger.tagName === 'BUTTON') {
          e.preventDefault();
        }
        
        if (trigger.getAttribute('aria-expanded') === 'true') {
          closeMenu(item, trigger, mega);
        } else {
          // Close others first
          if (currentOpen) closeMenu(currentOpen);
          openMenu(item, trigger, mega);
        }
      });

      // Keyboard navigation
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        } else if (e.key === 'Escape') {
          closeMenu(item, trigger, mega);
          trigger.focus();
        }
      });
    });

    // Dropdown interactions
    dropdownItems.forEach(item => {
      const trigger = item.querySelector('.pro-nav__link');
      const dropdown = item.querySelector('.pro-dropdown');
      if (!trigger || !dropdown) return;

      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        if (currentOpen && currentOpen !== item) {
          closeMenu(currentOpen);
        }
        setTimeout(() => {
          openMenu(item, trigger, dropdown);
        }, HOVER_DELAY);
      });

      item.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          closeMenu(item, trigger, dropdown);
        }, CLOSE_DELAY);
      });

      trigger.addEventListener('click', (e) => {
        if (trigger.tagName === 'BUTTON') {
          e.preventDefault();
          if (trigger.getAttribute('aria-expanded') === 'true') {
            closeMenu(item, trigger, dropdown);
          } else {
            if (currentOpen) closeMenu(currentOpen);
            openMenu(item, trigger, dropdown);
          }
        }
      });
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target) && currentOpen) {
        closeMenu(currentOpen);
      }
    });

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && currentOpen) {
        const trigger = currentOpen.querySelector('.pro-nav__link');
        closeMenu(currentOpen);
        if (trigger) trigger.focus();
      }
    });

    // Highlight current page
    highlightCurrentPage(nav);
  }

  function openMenu(item, trigger, menu) {
    trigger?.setAttribute('aria-expanded', 'true');
    menu?.setAttribute('aria-hidden', 'false');
    menu?.classList.add('is-active');
    currentOpen = item;
  }

  function closeMenu(item, trigger, menu) {
    if (!item) return;
    
    const t = trigger || item.querySelector('.pro-nav__link');
    const m = menu || item.querySelector('.pro-mega, .pro-dropdown');
    
    t?.setAttribute('aria-expanded', 'false');
    m?.setAttribute('aria-hidden', 'true');
    m?.classList.remove('is-active');
    
    if (currentOpen === item) {
      currentOpen = null;
    }
  }

  function highlightCurrentPage(nav) {
    const path = window.location.pathname;
    const links = nav.querySelectorAll('a[href]');
    
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (href === path || (path.startsWith(href) && href !== '/' && href.length > 1)) {
        link.classList.add('is-current');
        link.setAttribute('aria-current', 'page');
        
        // Highlight parent
        const item = link.closest('.pro-nav__item');
        if (item) {
          const parentLink = item.querySelector('.pro-nav__link');
          if (parentLink && parentLink !== link) {
            parentLink.classList.add('has-current-child');
          }
        }
      }
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
